module.exports = __webpack_public_path__ + "static/media/ddk-global-map-eng.4497041b.png";